import { EditorPickerPluginInterface } from 'roosterjs-plugin-picker/lib/PickerPlugin';
import atMentionsPluginTrigger from './utils/atMentionsPluginTrigger';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { lazyPickerPluginModule } from 'owa-editor-picker-plugin-module';

export type LazyAtMentionsPickerPlugin = LazyPlugin<EditorPickerPluginInterface>;

export let LazyAtMentionsPickerPluginClass = createLazyPlugin(
    lazyPickerPluginModule,
    m => m.PickerPlugin,
    'AtMentionsPicker',
    atMentionsPluginTrigger
);
